import * as Yup from 'yup';
import { Forsikring } from '@/components/Insurances';

export type FormValues = PersonalInfoValues | NjffValues;

export interface PersonalInfoValues {
    name?: string;
    telephone?: string;
    email?: string;
    foedselsdatoEllerOrgnr?: string;
    comment?: string;
}

export interface NjffValues extends PersonalInfoValues {
    type?: CustomerType;
    insurances: Forsikring[];
    insuranceDescription?: string;
}

export interface FormProps {
    onSubmit: (object: FormValues) => void;
    setPage: (page: Page) => void;
    page: Page;
    sentError: boolean;
    removeSentError: () => void;
}

export type Page = PartnerPage | NjffPage;
export type PartnerPage = 'personalInfo' | 'receipt';
export type NjffPage = 'personalInfo' | 'insurances' | 'receipt';

export type Partner = 'NJFF';
export const NJFF = 'NJFF';

export const NUMBER_OF_PARTNER_FORM_PAGES = 2;
export const NUMBER_OF_NJFF_FORM_PAGES = 3;

export type CustomerType = 'privat' | 'næring';
export const PRIVAT = 'privat';
export const NAERING = 'næring';

export type ValidationSchema<T> = StringSchema | ArraySchema<T>;
type StringSchema = Yup.StringSchema<string | undefined, Yup.AnyObject>;
type ArraySchema<T> = Yup.ArraySchema<T[] | undefined, Yup.AnyObject>;

export type StringField<T> = {
    validation: Yup.StringSchema<string | undefined, Yup.AnyObject>;
    initialValue: T;
    required: boolean;
};

export type ArrayField<T> = {
    validation: Yup.ArraySchema<T[] | undefined, Yup.AnyObject>;
    initialValue: T[];
    required: boolean;
};

export type FormFields = PersonalInfoFields | InsuranceFields;

export interface PersonalInfoFields {
    name: StringField<string>;
    telephone: StringField<string>;
    email: StringField<string>;
    foedselsdatoEllerOrgnr: StringField<string>;
    comment: StringField<string>;
}

export interface InsuranceFields extends PersonalInfoFields {
    type: StringField<CustomerType>;
    insuranceDescription: StringField<string>;
    insurances: ArrayField<string>;
}
